import { InvestorCapitalAccountDTO } from '../DTOs/capital-account/InvestorCapitalAccountDTO';

export class InvestorCapitalAccount {

  public uuid: string | null;
  public code: string;
  public name: string;
  public isGP = false;
  public commitment: number;

  constructor(
    uuid: string | null,
    code: string,
    name: string,
    isGP: boolean,
    commitment: number,
  ) {
    this.uuid = uuid;
    this.code = code;
    this.name = name;
    this.isGP = isGP;
    this.commitment = commitment;
  }

  static toDTO(investor: InvestorCapitalAccount): InvestorCapitalAccountDTO {
    return new InvestorCapitalAccountDTO(
      investor.uuid,
      investor.code,
      investor.name,
      investor.isGP,
      investor.commitment,
    );
  }

  static toDTOList(investors: InvestorCapitalAccount[]): InvestorCapitalAccountDTO[] {
    return investors.map((investor) => InvestorCapitalAccount.toDTO(investor));
  }
}
